module.exports = __webpack_public_path__ + "img/Nonmotor_acc_1.a1e1b6a7.jpg";